import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 1DDC71A0-A86A-4E8F-BF1D-CD33C0B0BEA4
 * name smoke-detector
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/smoke-detector.svg
 * tags
 * - Device / Tech 
 * - Home Automation 
 */
export const SmokeDetectorIcon = createSvgIcon(<><path d="M12,18A6,6 0 0,0 18,12C18,8.68 15.31,6 12,6C8.68,6 6,8.68 6,12A6,6 0 0,0 12,18M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19M8,12A4,4 0 0,1 12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12Z" /></>, 'SmokeDetectorIcon');
export default SmokeDetectorIcon